import { Component, Host, h, Prop, JSX } from '@stencil/core'
import { trans } from '~/store'

@Component({
    tag: 'zr-add-to-cart-count',
    styleUrl: 'zr-add-to-cart-count.scss',
    shadow: true,
})

/**
 * ZooRoyal price component.
 */
export class ZrAddToCartCount {
    /**
     * Product ID.
     */
    @Prop() productId: string

    /**
     * Quantity of product in cart.
     */
    @Prop() cartQuantity: number

    /**
     * Max quantity.
     */
    @Prop() maxQuantity = 100

    /**
     * Context used for tracking.
     */
    @Prop() context = 'default'

    /**
     * Disable add to cart.
     */
    @Prop() disabled = false

    /**
     * Aria label for add button.
     */
    @Prop() ariaLabelAdd = trans(
        'frontend/listing/addtocart.addProductsToCart',
        'Produkte zum Warenkorb hinzufügen'
    )

    /**
     * Aria label for remove button.
     */
    @Prop() ariaLabelRemove = trans(
        'frontend/listing/addtocart.removeProductsFromCart',
        'Produkte aus dem Warenkorb entfernen'
    )

    /**
     * Aria value text singular.
     */
    @Prop() ariaValueSingular = trans(
        'frontend/listing/addtocart.productsInCartSingular',
        'Ein Produkt im Warenkorb'
    )

    /**
     * Aria value text plural.
     */
    @Prop() ariaValuePlural = trans(
        'frontend/listing/addtocart.productsInCartPlural',
        'Produkte im Warenkorb'
    )

    /**
     * Aria labeled by.
     */
    @Prop() ariaLabeledBy: string | null = null

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <vx-add-to-cart-count
                    productId={parseInt(this.productId, 10)}
                    maxQuantity={this.maxQuantity}
                    quantity={this.cartQuantity}
                    disabled={this.disabled}
                    context={this.context}
                    ariaLabeledBy={this.ariaLabeledBy}
                    ariaLabelAdd={this.ariaLabelAdd}
                    ariaLabelRemove={this.ariaLabelRemove}
                    ariaValueSingular={this.ariaValueSingular}
                    ariaValuePlural={this.ariaValuePlural}
                />
            </Host>
        )
    }
}
